import { useToasterStore } from '../stores/toaster';

/**
 * Toaster mount — should be rendered once near the root of the app.
 * Stack of cards bottom-right, auto-dismiss based on ``durationMs``.
 *
 * Style alignment with the brand charter v2 (ADR-029/030/048):
 *   - success : bordure cat-fav (vert), pastel ``cat-fav-pastel``
 *   - error   : bordure cat-def (rouge), pastel ``cat-def-pastel``
 *   - info    : bordure accent (indigo), pastel ``accent-light``
 */
export default function Toaster() {
  const toasts = useToasterStore((s) => s.toasts);
  const dismiss = useToasterStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[9999] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-2"
      role="region"
      aria-label="Notifications"
    >
      {toasts.map((t) => {
        const cls =
          t.kind === 'success'
            ? 'border-cat-fav/40 bg-cat-fav-pastel text-cat-fav'
            : t.kind === 'error'
              ? 'border-cat-def/40 bg-cat-def-pastel text-cat-def'
              : 'border-accent/40 bg-accent-light text-accent-text';
        return (
          <div
            key={t.id}
            role={t.kind === 'error' ? 'alert' : 'status'}
            className={`pointer-events-auto flex items-start justify-between gap-2 rounded-md border bg-paper-elevated px-3 py-2 text-sm shadow-md ${cls}`}
          >
            <span className="flex-1 whitespace-pre-wrap">{t.message}</span>
            <button
              onClick={() => dismiss(t.id)}
              className="rounded p-1 text-text-tertiary hover:bg-paper-subtle hover:text-text-primary"
              aria-label="Fermer la notification"
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>
  );
}
